import { render } from "./LabGrown.vue?vue&type=template&id=44439060"
import script from "./LabGrown.vue?vue&type=script&lang=js"
export * from "./LabGrown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__